import * as Yup from "yup";

export const initialValues = {
  ShipToNumber: "",
  ShipToName: "",
  SAPPlantId: "",
  ShipToAddressLine1: "",
  ShipToAddressLine2: "",
  ShipToAddressLine3: "",
  ShipToCity: "",
  ShipToPostCode: "",
  ShipToEmail: "",
  CarrierEmail: "",
};

export const AddShipToMappingSchema = Yup.object().shape({
  // Required fields
  ShipToNumber: Yup.string()
    .trim()
    .matches(
      /^[A-Za-z0-9][A-Za-z0-9 _./-]{1,30}$/,
      "Ship to number must be 1-30 characters, alphanumeric and space, - _ . / special characters are allowed."
    )
    .label("Ship to Number")
    .required(),
  ShipToName: Yup.string()
    .trim()
    .matches(
      /^[\p{L}\p{N}\p{P}\s]{2,50}$/u,
      "Ship to name must be 2-50 characters, letters, digits, spaces, punctuation and diacritics are allowed."
    )
    .label("Ship to Name")
    .required(),
  SAPPlantId: Yup.string().label("SAP Plant ID").required(),
  ShipToAddressLine1: Yup.string()
    .trim()
    .matches(
      /^[A-Za-z0-9\s#/,.'-]{1,70}$/,
      "Ship to address line 1 must be 1-70 characters, alphabets, numbers and space, #, /, ,, ., ', - special characters are allowed."
    )
    .label("Ship To Address Line 1")
    .required(),
  ShipToAddressLine2: Yup.string()
    .trim()
    .matches(
      /^[A-Za-z0-9\s#/,.'-]{1,70}$/,
      "Ship to address line 2 must be 1-70 characters, alphabets, numbers and space, #, /, ,, ., ', - special characters are allowed."
    )
    .label("Ship To Address Line 2")
    .optional(),
  ShipToAddressLine3: Yup.string()
    .trim()
    .matches(
      /^[A-Za-z0-9\s#/,.'-]{1,70}$/,
      "Ship to address line 3 must be 1-70 characters, alphabets, numbers and space, #, /, ,, ., ', - special characters are allowed."
    )
    .label("Ship To Address Line 3")
    .optional(),
  ShipToCity: Yup.string()
    .trim()
    .matches(
      /^[A-Za-z][A-Za-z\s'.-]{1,59}$/,
      "Ship to city must be 1-59 characters, alphabets only and space, ', ., - special characters are allowed."
    )
    .label("Ship To City")
    .required(),
  ShipToPostCode: Yup.string()
    .trim()
    .matches(
      /^\d{4}$/,
      "Ship to postal code must be exactly 4 digits."
    )
    .label("Ship To Postal Code")
    .required(),
  ShipToEmail: Yup.string()
    .trim()
    .label("Ship To Email")
    .required()
    .test(
      'valid-emails',
      'Must contain at least one valid email address. Multiple emails can be separated by semicolons.',
      function (value) {
        if (!value) return false;

        // Split by semicolon and trim whitespace
        const emails = value.split(';').map((email) => email.trim());

        // Reject if any empty segment exists
        if (emails.some((email) => email.length === 0)) {
          return false;
        }

        // Require every email to be valid
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emails.every((email) => emailRegex.test(email));
      }
    ),
  CarrierEmail: Yup.string()
    .trim()
    .label("Carrier Email")
    .required()
    .test(
      'valid-emails',
      'Must contain at least one valid email address. Multiple emails can be separated by semicolons.',
      function (value) {
        if (!value) return false;

        // Split by semicolon and trim whitespace
        const emails = value.split(';').map((email) => email.trim());

        // Reject if any empty segment exists
        if (emails.some((email) => email.length === 0)) {
          return false;
        }

        // Require every email to be valid
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emails.every((email) => emailRegex.test(email));
      }
    ),
});
